{
  "fr": {
    "analytics": {
      "labels": {
        "allUnits": "Toutes les unités",
        "click_seen_by": "Cliquez pour plus d'informations",
        "click_shared_with": "Cliquer pour savoir avec quels clients cela est partagé",
        "deleted": "Supprimé",
        "deleted_item": "Cet élément a été supprimé et n'est plus cliquable",
        "noCustomers": "Aucun client n'est encore affecté à ce niveau.",
        "noCustomersSeen": "Aucun client ne l'a encore vu.",
        "noCustomersUnseen": "Tous les clients ont vu cela",
        "noUnitAccess": "Pas d'accès à l'unité",
        "notSeen": "Pas vue ({number})",
        "seen": "Vue ({number})",
        "seenAt": "Vu {date}",
        "seenBy": "Vu par",
        "seen_by_all": "Vu par tout le monde. Cliquez pour voir qui l'a vu.",
        "sharedWithMultipleUnits": "Partagé avec zero clients dans {level_name} | Partagé avec 1 client dans {level_name} | Partagé avec {customers_count} clients dans {level_name}",
        "sharedWithUnit": "Partagé avec {unit_name}",
        "units": "Pas d'Unité | Une Unité | {count} Unités",
        "unseenOfTotal": "{unseen} sur {total} ne l'ont pas encore vue",
        "views": "Vues",
        "viewsCount": "Pas de Vues | 1 Vue | {count} Vues",
        "whoSeenAnnouncement": "Qui a vu cette annonce"
      }
    }
  }
}
